import jwt_decode from "jwt-decode";
import { JWTToken } from "../routes/privateRoute";

/**
 * Lê o token da sessão SEM derrubar a aplicação.
 *
 * O padrão espalhado pelas telas era `jwt_decode(token || "")` direto no corpo
 * do componente. Isso roda durante o render e a lib lança InvalidTokenError
 * quando o token não existe, está vazio ou veio corrompido — e exceção no
 * render desmonta a árvore inteira do React, que é a tela branca ao dar F5 com
 * a sessão expirada.
 *
 * Aqui a falha vira um objeto vazio: a tela renderiza sem os dados do usuário
 * e o PrivateRoute manda para o login, que é o comportamento desejado.
 */
export function decodificarToken(token?: string | null): JWTToken | null {
  if (!token || typeof token !== "string" || !token.includes(".")) return null;

  try {
    return jwt_decode<JWTToken>(token);
  } catch (error) {
    console.error("Token inválido ao decodificar:", error);
    return null;
  }
}

/** Token da sessão, do cookie `auth` ou do localStorage. */
export function tokenDaSessao(): string | null {
  return window.localStorage.getItem("token");
}

/**
 * Versão para quem só precisa dos campos e não quer tratar null — devolve um
 * objeto vazio no lugar de estourar.
 */
export function dadosDoToken(token?: string | null): Partial<JWTToken> {
  return decodificarToken(token) ?? {};
}
